// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-video[data-v-4c0cd797] {
  max-width: 100%;
  height: 100%;
  aspect-ratio: 16/9;
  object-fit: cover;
}
.no-video[data-v-4c0cd797] {
  width: 100%;
  height: 100%;
}
.video-tile[data-v-4c0cd797] {
  position: relative;
  width: 120px;
  height: 90px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color 0.2s;
}
.video-tile.active[data-v-4c0cd797] {
  border-color: #6eff5d;
}
.video-tile[data-v-4c0cd797]:hover {
  border-color: #55b647;
}
.participant-video[data-v-4c0cd797] {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.video-label[data-v-4c0cd797] {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  padding: 2px 5px;
}
.video-controls[data-v-4c0cd797] {
  position: absolute;
  top: 5px;
  right: 5px;
  display: flex;
  gap: 2px;
}
.control-indicator[data-v-4c0cd797] {
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
}
.controls-overlay[data-v-4c0cd797] {
  margin-bottom: 1vh;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 25px;
  padding: 10px 20px;
  transition: opacity 0.3s;
}
.controls-overlay[data-v-4c0cd797]:hover {
  background: rgba(0, 0, 0, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/pages/community/GroupVideoPage.vue","webpack://./GroupVideoPage.vue"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;ACDF;ADIA;EACE,WAAA;EACA,YAAA;ACDF;ADIA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,6BAAA;ACDF;ADIA;EACE,qBAAA;ACDF;ADIA;EACE,qBAAA;ACDF;ADIA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;ACDF;ADIA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,8BAAA;EACA,gBAAA;ACDF;ADIA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,QAAA;ACDF;ADIA;EACE,8BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;ACDF;ADIA;EACE,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;ACDF;ADGE;EACE,8BAAA;ACDJ","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.main-video {\n  max-width: 100%;\n  height: 100%;\n  aspect-ratio: 16/9;\n  object-fit: cover;\n}\n\n.no-video {\n  width: 100%;\n  height: 100%;\n}\n\n.video-tile {\n  position: relative;\n  width: 120px;\n  height: 90px;\n  border-radius: 8px;\n  overflow: hidden;\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: border-color 0.2s;\n}\n\n.video-tile.active {\n  border-color: #6eff5d;\n}\n\n.video-tile:hover {\n  border-color: #55b647;\n}\n\n.participant-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.video-label {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.7);\n  padding: 2px 5px;\n}\n\n.video-controls {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  display: flex;\n  gap: 2px;\n}\n\n.control-indicator {\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 5px;\n}\n\n.controls-overlay {\n  margin-bottom: 1vh;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 25px;\n  padding: 10px 20px;\n  transition: opacity 0.3s;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.5);\n  }\n}\n",".main-video {\n  max-width: 100%;\n  height: 100%;\n  aspect-ratio: 16/9;\n  object-fit: cover;\n}\n\n.no-video {\n  width: 100%;\n  height: 100%;\n}\n\n.video-tile {\n  position: relative;\n  width: 120px;\n  height: 90px;\n  border-radius: 8px;\n  overflow: hidden;\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: border-color 0.2s;\n}\n\n.video-tile.active {\n  border-color: #6eff5d;\n}\n\n.video-tile:hover {\n  border-color: #55b647;\n}\n\n.participant-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.video-label {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.7);\n  padding: 2px 5px;\n}\n\n.video-controls {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  display: flex;\n  gap: 2px;\n}\n\n.control-indicator {\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 5px;\n}\n\n.controls-overlay {\n  margin-bottom: 1vh;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 25px;\n  padding: 10px 20px;\n  transition: opacity 0.3s;\n}\n.controls-overlay:hover {\n  background: rgba(0, 0, 0, 0.5);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
